module.exports = __webpack_public_path__ + "/img/at-icon.80540a5226.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/at-icon.png
// module id = 1388
// module chunks = 0